/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown>, "count, plural, one {": NonNullable<unknown>, s: NonNullable<unknown> }} Knp_Lookup_Showing_Guides_InfoInputs */

const en_knp_lookup_showing_guides_info = /** @type {(inputs: Knp_Lookup_Showing_Guides_InfoInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Showing ${i?.count} accessible guide${i?.["count, plural, one {"]} other ${i?.s}}.`)
};

const fr_knp_lookup_showing_guides_info = /** @type {(inputs: Knp_Lookup_Showing_Guides_InfoInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Affichage de ${i?.count} guide${i?.["count, plural, one {"]} other ${i?.s}} accessible${i?.["count, plural, one {"]} other ${i?.s}}.`)
};

const de_knp_lookup_showing_guides_info = /** @type {(inputs: Knp_Lookup_Showing_Guides_InfoInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Barrierefreiheitsleitfaden ${i?.count} und${i?.["count, plural, one {"]} other ${i?.s}} werden angezeigt.`)
};

const it_knp_lookup_showing_guides_info = /** @type {(inputs: Knp_Lookup_Showing_Guides_InfoInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Visualizzazione della guida accessibile ${i?.count}${i?.["count, plural, one {"]} other ${i?.s}}.`)
};

const ru_knp_lookup_showing_guides_info = /** @type {(inputs: Knp_Lookup_Showing_Guides_InfoInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Отображение доступного руководства ${i?.count}${i?.["count, plural, one {"]} other ${i?.s}}.`)
};

const es_knp_lookup_showing_guides_info = /** @type {(inputs: Knp_Lookup_Showing_Guides_InfoInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Mostrando ${i?.count} guía accesible${i?.["count, plural, one {"]} other ${i?.s}}.`)
};

const zh_cn2_knp_lookup_showing_guides_info = /** @type {(inputs: Knp_Lookup_Showing_Guides_InfoInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`显示 ${i?.count} 无障碍指南${i?.["count, plural, one {"]} other ${i?.s}}。`)
};

const ja_knp_lookup_showing_guides_info = /** @type {(inputs: Knp_Lookup_Showing_Guides_InfoInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} アクセス可能なガイド${i?.["count, plural, one {"]} other ${i?.s}} を表示しています。`)
};

const hi_knp_lookup_showing_guides_info = /** @type {(inputs: Knp_Lookup_Showing_Guides_InfoInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} सुलभ गाइड${i?.["count, plural, one {"]} other ${i?.s}} प्रदर्शित कर रहा है।`)
};

const pt_pt2_knp_lookup_showing_guides_info = /** @type {(inputs: Knp_Lookup_Showing_Guides_InfoInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Exibindo o guia de acessibilidade ${i?.count}_${i?.["count, plural, one {"]} other ${i?.s}}.`)
};

/**
* | output |
* | --- |
* | "Showing {count} accessible guide{count, plural, one {} other {s}}." |
*
* @param {Knp_Lookup_Showing_Guides_InfoInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const knp_lookup_showing_guides_info = /** @type {((inputs: Knp_Lookup_Showing_Guides_InfoInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Knp_Lookup_Showing_Guides_InfoInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_knp_lookup_showing_guides_info(inputs)
	if (locale === "de") return de_knp_lookup_showing_guides_info(inputs)
	if (locale === "it") return it_knp_lookup_showing_guides_info(inputs)
	if (locale === "ru") return ru_knp_lookup_showing_guides_info(inputs)
	if (locale === "es") return es_knp_lookup_showing_guides_info(inputs)
	if (locale === "zh-CN") return zh_cn2_knp_lookup_showing_guides_info(inputs)
	if (locale === "ja") return ja_knp_lookup_showing_guides_info(inputs)
	if (locale === "hi") return hi_knp_lookup_showing_guides_info(inputs)
	if (locale === "pt-PT") return pt_pt2_knp_lookup_showing_guides_info(inputs)
	return en_knp_lookup_showing_guides_info(inputs)
});